import { CustomIconsType } from '../../../types/common';

const AndroidLogo = ({ size = 32, fill = 'black' }: CustomIconsType) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5034 14.787C9.23704 14.787 9.83179 15.3817 9.83179 16.1154V21.8138C9.83179 22.5474 9.23704 23.1421 8.5034 23.1421C7.76986 23.1421 7.17511 22.5474 7.17511 21.8138V16.1154C7.17511 15.3818 7.76986 14.7871 8.5034 14.7871V14.787Z"
      fill={fill}
    />
    <path
      d="M5.47085 7.93591C5.46647 7.98628 5.46265 8.03721 5.46265 8.0887V16.7223C5.46265 17.6508 6.19759 18.3988 7.10995 18.3988H15.8897C16.8022 18.3988 17.5371 17.6507 17.5371 16.7223V8.0887C17.5371 8.03721 17.5353 7.9861 17.531 7.93591H5.47085Z"
      fill={fill}
    />
    <path
      d="M14.4965 14.787C15.2301 14.787 15.8249 15.3817 15.8249 16.1154V21.8138C15.8249 22.5474 15.2301 23.1421 14.4965 23.1421C13.7629 23.1421 13.1682 22.5474 13.1682 21.8138V16.1154C13.1682 15.3818 13.7629 14.7871 14.4965 14.7871V14.787ZM3.32839 8.70426C4.06193 8.70426 4.65668 9.29901 4.65668 10.0327V15.7311C4.65668 16.4647 4.06193 17.0594 3.32839 17.0594C2.59475 17.0594 2 16.4647 2 15.7312V10.0327C1.99991 9.2991 2.59465 8.70426 3.32839 8.70426ZM19.6717 8.70426C20.4052 8.70426 21 9.29901 21 10.0327V15.7311C21 16.4647 20.4052 17.0594 19.6717 17.0594C18.9381 17.0594 18.3433 16.4647 18.3433 15.7312V10.0327C18.3433 9.2991 18.9381 8.70426 19.6717 8.70426ZM5.50971 7.36879C5.54665 4.71687 7.86128 2.54253 10.8324 2.25598H12.1674C15.1387 2.54263 17.4532 4.71705 17.4901 7.36879H5.50971Z"
      fill={fill}
    />
    <path
      d="M5.97168 2L7.37292 4.42712M17.0283 2L15.627 4.42712"
      stroke={fill}
      strokeWidth="0.279837"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.71547 4.9922C9.71659 5.36289 9.4098 5.66427 9.03015 5.6653C8.65069 5.66623 8.34213 5.36662 8.34101 4.99593V4.9922C8.33998 4.62141 8.64677 4.32012 9.02633 4.31909C9.40579 4.31807 9.71435 4.61759 9.71547 4.98846V4.9922ZM14.8454 4.9922C14.8466 5.36289 14.5398 5.66427 14.1601 5.6653C13.7807 5.66623 13.4721 5.36662 13.471 4.99593V4.9922C13.47 4.62141 13.7767 4.32012 14.1563 4.31909C14.5358 4.31807 14.8443 4.61759 14.8454 4.98846V4.9922Z"
      fill="white"
    />
  </svg>
);

export default AndroidLogo;
